var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3334 5H7.33334C6.6 5 6 5.6 6 6.33333V15.6666H7.33334V6.33333H15.3334V5ZM17.3334 7.66666H10C9.26667 7.66666 8.66667 8.26666 8.66667 9V18.3333C8.66667 19.0666 9.26667 19.6666 10 19.6666H17.3334C18.0667 19.6666 18.6666 19.0666 18.6666 18.3333V9C18.6666 8.26666 18.0667 7.66666 17.3334 7.66666ZM17.3334 18.3333H10V9H17.3334V18.3333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.e5ce801ffa6056e67280fac318b22d83.svg";
export { ForwardRef as ReactComponent };